export default __webpack_public_path__ + "static/media/american.28457265.png";